import { Form, FormikProvider, useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { Button, } from 'react-bootstrap';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import PersonalDetailsReport from './PersonalDetailsReport';
import * as Yup from "yup";
import { ALPHABETS_ONLY, ALPHABETS_ONLY_Msg, AddresRemarks, Addres_Msg, ERROR_MSG, PINCODE } from '../../../CommonUtilities/Validations/RegularExpAndVar';
import Sweetalert from '../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { getMinimumEligibleDOB } from '../../../CommonUtilities/Validations/Validations';


export default function CandidateProfile({ handleNext }) {
    const tabdetails = useSelector((state) => state.reducers.loginreducer.tabdetails);
    const casteData = useSelector((state) => state.reducers.loginreducer.casteDetails);
  const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);
//   console.log("loginreducer::", loginreducer)
    const [showPhotoStatus, setPhotoStatus] = useState(false)
    const [showdata, setData] = useState()
    // const [isConfirm, setIsConfirm] = useState(false)
    // function getconfirmationData() {
    //     let Url = config.url.CONTEXT_URL + "candidate-confirmation"
    //     CommonAxiosGet(Url).then((res) => {
    //         if (res?.data?.status === true) {
    //             if (res?.data?.data[0]?.personal_details_check === true) {
    //                 setIsConfirm(true)
    //                 setPhotoStatus(true)
    //             }
    //         }
    //     })
    // }
    const [showDscVerifiedPic, setDscVerifiedPic] = useState(null);
    function getData() {
        let Url = config.url.CONTEXT_READ_URL + "candidate-details"
        CommonAxiosGet(Url).then((res) => {
            if (res?.data?.status === true) {
                setData(res?.data?.data[0])
                let data = res?.data?.data[0]

                setDscVerifiedPic(data?.dsc_2025);


                Formik.setFieldValue('aadhaarNo', data?.aadhaar_no)
                Formik.setFieldValue('applicantName', data?.applicant_name)
                // if (data?.img_path) {
                //     setPhotoStatus(true)
                // }
                Formik.setFieldValue('imgPath', data?.img_path ? data?.img_path : '')
                Formik.setFieldValue('fatherName', data?.father_name)
                Formik.setFieldValue('motherName', data?.mother_name)
                Formik.setFieldValue('surName', data?.surname)
                Formik.setFieldValue('mobileNo', data?.mobile_no)
                Formik.setFieldValue('gender', data?.gender)
                Formik.setFieldValue('maritalStatus', data?.marital_status);
                const castelabell = [{ value: data?.caste_code, label: data?.caste_code }]
                setSelectedValue(castelabell);
                let corpdaata = casteData?.totalCasteList?.filter((val) => val?.caste_code === data?.caste);
                let sub = corpdaata?.map((subcaste) => (
                    { value: subcaste.sub_caste_code, label: `${subcaste.sub_caste_name}(${subcaste.sub_caste_name_in_telugu})` }));
                setSubCastes(sub);
                let selected_sub = sub?.filter((val) => val?.value === data?.sub_caste_code)
                setSelectedsubcasteValue(selected_sub);
                Formik.setFieldValue('caste', data?.caste)
                Formik.setFieldValue('subCasteCode', data?.sub_caste_code)
                if (data?.caste === 'OC') {
                    Formik.setFieldValue('isEws', data?.is_ews ? 'true' : 'false')
                }

                Formik.setFieldValue('dob', data?.dob)
                Formik.setFieldValue('address', data?.address)
                Formik.setFieldValue('email', data?.email)
                Formik.setFieldValue('doorNo', data?.door_no)
                Formik.setFieldValue('pinCode', data?.pin_code)
                Formik.setFieldValue('isAndhra', data?.is_andhra ? 'true' : 'false')
                if (data?.is_andhra === false) {
                    Formik.setFieldValue('state', data?.state)
                    Formik.setFieldValue('district', data?.dist_name)
                    Formik.setFieldValue('mandal', data?.mandal_name)
                }
                else if (data?.is_andhra === true) {

                    Formik.setFieldValue('district', data?.district)
                    Formik.setFieldValue('village', data?.village)
                    Formik.setFieldValue('mandal', data?.mandal)
                }

                Formik.setFieldValue('isPh', data?.is_ph ? 'true' : 'false')
                if (data?.is_ph === true) {
                    Formik.setFieldValue('isScribe', data?.is_scribe ? 'true' : 'false')
                    Formik.setFieldValue('isVh', data?.is_vh)
                    Formik.setFieldValue('isOh', data?.is_oh)
                    Formik.setFieldValue('isHi', data?.is_hi)
                    Formik.setFieldValue('isMi', data?.is_mi)
                    if (data?.is_vh) {
                        Formik.setFieldValue('vhPercentage', data?.vh_percentage)
                    }
                    if (data?.is_hi) {
                        Formik.setFieldValue('hiPercentage', data?.hi_percentage)
                    }
                    if (data?.is_oh) {
                        Formik.setFieldValue('ohPercentage', data?.oh_percentage)
                    }
                    if (data?.is_mi) {
                        Formik.setFieldValue('miPercentage', data?.mi_percentage)
                    }
                }
                setIsEdit(data?.is_gov_school !== null ? false : true)
                Formik.setFieldValue('isExServiceMen', data?.is_ex_service_men ? 'true' : 'false');


                Formik.setFieldValue('managementId', data?.is_gov_school === true ? data?.management_id : "");
                Formik.setFieldValue('exService', data?.is_ex_service_men ? data?.ex_service : '')
            }
        })
    }

    useEffect(() => {
        getData()
        // getconfirmationData()
    }, [])
    const today = moment();
    const minAge = 18;
    const maxAge = 65;
    const appValidationSchema = Yup.object().shape({

        candidatePhoto: Yup.string().nullable().when('imgPath', {
            is: (imgPath) => {
                return (!imgPath)
            },
            then: Yup.string().required(ERROR_MSG),
            oterwise: Yup.string(),
        }),
        fatherName: Yup.string().required(ERROR_MSG).nullable().matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
        motherName: Yup.string().required(ERROR_MSG).nullable().matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
        gender: Yup.string().required(ERROR_MSG).nullable(),
        maritalStatus: Yup.string().required(ERROR_MSG).nullable(),
 
        caste: Yup.string().required(ERROR_MSG), subCasteCode: Yup.string().required(ERROR_MSG),
        isEws: Yup.string().when("caste", {
            is: (caste) => (caste === "OC"),
            then: Yup.string().required(ERROR_MSG),
            oterwise: Yup.string(),
        }),
        // dob: Yup.date()
        //     .required("Date of Birth is required")
        //     .test(
        //         "age-range",
        //         `Age must be between ${minAge} and ${maxAge} years`,
        //         (value) => {
        //             if (!value) return false;
        //             const birthDate = moment(value);
        //             const age = today.diff(birthDate, "years");
        //             return age >= minAge && age <= maxAge;
        //         }
        //     ),
        // ********For dsc ******************
        // dob: Yup.date().required(ERROR_MSG).test('validDob', 'Invalid dob', (value, context) => {
        //     if (!value) return true;
        //     const { caste, isEws, isPh, isExServiceMen, exService } = context.parent;
        //     const cutoffDate = moment('2024-07-01');
        //     const minAgeDate = moment(cutoffDate).subtract(18, 'years');
        //     if (moment(value).isAfter(minAgeDate)) return false;
        //     const minEligibleDOB = getMinimumEligibleDOB({
        //         caste, isEws, isPh, isExServiceMen, exService
        //     });
        //     return moment(value).isBetween(minEligibleDOB, cutoffDate, 'day', '[]');
        // }).max(moment('2006-07-01').format('YYYY-MM-DD'), 'Must be at least 18 years old as of 01.07.2024'),
dob: Yup.date()
  .required(ERROR_MSG)
  .test('validDob', 'Age not within allowed limits as per G.O', function (value,context) {
    if (!value) return true;

    const { caste, isEws, isPh, isExServiceMen } = context.parent;

    const cutoffDate = moment('2025-07-01');

    const maxDOB = moment(cutoffDate).subtract(18, 'years'); 

    if (moment(value,context).isAfter(maxDOB)) {
      return context.createError({
        message: 'Must be at least 18 years as on 01-07-2025'
      });
    }
    const minDOB = getMinimumEligibleDOB({ caste, isEws, isPh, isExServiceMen });
    if (moment(value,context).isBefore(minDOB)) {
      return context.createError({
        message: 'Age exceeds maximum limit as per G.O'
      });
    }

    return true;
  }),
 
  email: Yup.string().required(ERROR_MSG).nullable().email('Invalid email address'),
        doorNo: Yup.string().required(ERROR_MSG).nullable(),
        pinCode: Yup.string().matches(PINCODE, "Enter a valid PIN code").length(6, "PIN code must be exactly 6 digits").required(ERROR_MSG).nullable(),
        address: Yup.string().required(ERROR_MSG).nullable().matches(AddresRemarks, Addres_Msg),
        isExServiceMen: Yup.string().required(ERROR_MSG).nullable(),
        exService: Yup.string().when("isExServiceMen", {
            is: (isExServiceMen) => (isExServiceMen === "true" || isExServiceMen === true),
            then: Yup.string().required(ERROR_MSG).nullable(),
            oterwise: Yup.string().nullable(),
        }),

        isPh: Yup.string().required(ERROR_MSG).nullable(),
        // isScribe: Yup.string().when("isPh", {
        //     is: (isNative) => (isNative === "true"),
        //     then: Yup.string().required(ERROR_MSG),
        //     oterwise: Yup.string().nullable(),
        // }),
        isVh: Yup.boolean().nullable(),
        vhPercentage: Yup.string().when(['isVh', 'isPh'], {
            is: (isVh, isPh) => isVh === true && isPh === "true",
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        isHi: Yup.boolean().nullable(),
        hiPercentage: Yup.string().when(['isHi', 'isPh'], {
            is: (isHi, isPh) => isHi === true && isPh === "true",
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        isOh: Yup.boolean().nullable(),
        ohPercentage: Yup.string().when(['isOh', 'isPh'], {
            is: (isOh, isPh) => isOh === true && isPh === "true",
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        isMi: Yup.boolean().nullable(),
        miPercentage: Yup.string().when(['isMi', 'isPh'], {
            is: (isMi, isPh) => isMi === true && isPh === "true",
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),
        isAndhra: Yup.string().required(ERROR_MSG),
        state: Yup.string().when("isAndhra", {
            is: (isNative) => (isNative === "false"),
            then: Yup.string().required(ERROR_MSG).nullable(),
            oterwise: Yup.string(),
        }),
        district: Yup.string().when('isAndhra', {
            is: 'false',
            then: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
            otherwise: Yup.string().required(ERROR_MSG),
        }),
        mandal: Yup.string().when('isAndhra', {
            is: 'false',
            then: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
            otherwise: Yup.string().required(ERROR_MSG),
        }),
        village: Yup.string().when("isAndhra", {
            is: (isNative) => (isNative === "true"),
            then: Yup.string().required(ERROR_MSG).nullable(),
            oterwise: Yup.string().nullable(),
        }),
    }).test("myCustomCheckboxTest", function (obj) {
        if (obj.isPh === "true") {
            if (obj.isOh || obj.isHi || obj.isMi || obj.isVh) {
                return true; // everything is fine
            }
            return new Yup.ValidationError(
                "Check at least one checkbox",
                null,
                "isMi");
        }
    });
    let dispatch = useDispatch()
    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            candidatePhoto: "",
            aadhaarNo: "",
            applicantName: "",
            surName:"",
            imgPath: "",
            fatherName: "",
            motherName: "",
            mobileNo: "",
            gender: "",
            maritalStatus: "",
            caste: "",
            subCasteCode: "",
            isEws: "",
            claimingDistrict: "",
            dob: "",
            district: "",
            address: "",
            village: "",
            email: "",
            doorNo: "",
            pinCode: "",
            isSports: "",
            mandal: "",
            isAndhra: "",
            isPh: "",
            isVh: '',
            isOh: "",
            isHi: "",
            isMi: "",
            // isScribe: '',
            vhPercentage: '',
            hiPercentage: '',
            ohPercentage: '',
            miPercentage: "",
            otp: '',
            selfCheck: '',
            isExServiceMen: "",
            exService: '',
            state: "",
            managementId: ""
        },
        onSubmit: (values) => {
    //    console.log("DOB:", values.dob , "Caste" , values.caste, "isEws", values.isEws, "isPh", values.isPh, "isExServiceMen", values.isExServiceMen);
            let url = config.url.CONTEXT_URL + "candidate-registration-update"
            CommonAxiosPost(url, values).then((res) => {
                if (res?.data?.status === true) {
                    Sweetalert("Successfully Saved","success")
                    getData();
                    // dispatch({ type: "SHOW_TAB_DETAILS", payload: { latestTab: 2, confirm: false } });
                    handleNext();
                    setIsEdit(false);
                }
                else {
                    Sweetalert(res?.data?.sdesc, "error")
                }
            })
        },
        validationSchema: appValidationSchema,
    })
    const [isEdit, setIsEdit] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const [subCastes, setSubCastes] = useState();
    const [selectedsubcasteValue, setSelectedsubcasteValue] = useState(null);

    const handleCasteChange = async (value) => {
        let sub = casteData?.totalCasteList?.filter((val) => val?.caste_code === value)?.map((subcaste) => ({ value: subcaste.sub_caste_code, label: `${subcaste.sub_caste_name}(${subcaste.sub_caste_name_in_telugu})` }));
        Formik.setFieldValue('caste', value);
        Formik.setFieldValue('subCasteCode', '');
        setSelectedsubcasteValue(null); setSelectedValue(value); setSubCastes(sub)
    }
    return (
        <React.Fragment>
            <FormikProvider value={Formik}>
                <Form className="form-section" onSubmit={Formik.handleSubmit} onChange={Formik.handleChange}>
                    <PersonalDetailsReport Formik={Formik} showdata={showdata} isEdit={isEdit}
                        selectedsubcasteValue={selectedsubcasteValue} subCastes={subCastes} Castes={casteData?.casteCodeList}
                        handleCasteChange={handleCasteChange} setSelectedsubcasteValue={setSelectedsubcasteValue}
                        selectedValue={selectedValue} isRead={true} preview={showPhotoStatus} dscVerifiedPic={showDscVerifiedPic} />

                    {tabdetails?.confirm === false ? (
                        <div className='float-end text-end w-100 mb-4 mt-3'>
                            {isEdit === false ?
                                <Button variant="" type="button" onClick={() => { setIsEdit(true); setPhotoStatus(false); }}
                                    className="btn btn-primary" >
                                    Edit
                                </Button>
                                : ""}  &emsp;
                            {(showdata?.img_path && showdata?.is_gov_school !== null && isEdit === false) && <Button variant="" type="button"
                                className="btn btn-secondary me-2" onClick={() => { handleNext() }} >
                                Next
                            </Button>}
                            &emsp;
                            {(!showdata?.img_path || isEdit === true) &&
                                <Button variant="success" type="submit" className="submit-btn btn-success me-2" >
                                    Save & Continue
                                </Button>}
                        </div>) : ''}

                </Form>
            </FormikProvider>
        </React.Fragment>
    )
}
